import { render, staticRenderFns } from "./ActiveSign.vue?vue&type=template&id=172e4ca3&"
import script from "./ActiveSign.vue?vue&type=script&lang=js&"
export * from "./ActiveSign.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172e4ca3')) {
      api.createRecord('172e4ca3', component.options)
    } else {
      api.reload('172e4ca3', component.options)
    }
    module.hot.accept("./ActiveSign.vue?vue&type=template&id=172e4ca3&", function () {
      api.rerender('172e4ca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/febos/ActiveSign.vue"
export default component.exports